(() => {
  'use strict';

  if (window.SmartMakroBundleUpgradeLoaded) return;
  window.SmartMakroBundleUpgradeLoaded = true;

  const rootPath = () => window.Shopify?.routes?.root || '/';

  const showMessage = (root, message, isError = false) => {
    const node = root.querySelector('[data-sm-bundle-message]');
    if (!node) return;

    node.textContent = message || '';
    node.hidden = !message;
    node.classList.toggle('is-error', Boolean(isError));
  };

  const collectCartSections = () => {
    const sections = [];

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections }
      })
    );

    return [...new Set(sections.filter(Boolean))];
  };

  const openCartDrawer = (trigger = null) => {
    const drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('.cart-drawer');

    if (!drawer) return;

    try {
      if (typeof drawer.show === 'function') {
        drawer.show(trigger);
        return;
      }
    } catch (_) {}

    try {
      drawer.removeAttribute('hidden');
      drawer.setAttribute('open', '');
      drawer.classList.add('is-open');
    } catch (_) {}
  };

  const publishCart = (cart) => {
    try {
      const events =
        window.FoxTheme?.pubsub?.PUB_SUB_EVENTS;

      if (
        window.FoxTheme?.pubsub &&
        events?.cartUpdate
      ) {
        window.FoxTheme.pubsub.publish(
          events.cartUpdate,
          {
            cart,
            open: true,
            source: 'smartmakro-bundle-upgrade'
          }
        );

        return true;
      }
    } catch (error) {
      console.warn(
        'Smart Makro bundle: cart update event fejlede.',
        error
      );
    }

    return false;
  };

  const refreshDrawerFallback = () => {
    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: {
          open: true
        }
      })
    );
  };

  const addBundle = async (root, button) => {
    const variantId =
      Number(root.dataset.bundleVariantId);

    if (
      !variantId ||
      root.classList.contains('is-loading')
    ) {
      return;
    }

    root.classList.add('is-loading');
    button.disabled = true;

    const originalText = button.textContent;

    button.textContent = 'Tilføjer pakken…';

    showMessage(root, '');

    try {
      /*
       * FoxTheme opdaterer cart drawer via
       * renderede Shopify sections.
       *
       * Derfor sender vi section-id'erne med
       * direkte i /cart/add.js.
       */

      const sections = collectCartSections();

      const addResponse = await fetch(
        `${rootPath()}cart/add.js`,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },

          credentials: 'same-origin',

          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ],

            sections,

            sections_url:
              window.location.pathname
          })
        }
      );

      const addResult =
        await addResponse.json();

      if (!addResponse.ok) {
        throw new Error(
          addResult.description ||
          addResult.message ||
          'Pakken kunne ikke tilføjes.'
        );
      }

      /*
       * Hent den komplette nye kurv.
       */

      const cartResponse = await fetch(
        `${rootPath()}cart.js`,
        {
          credentials: 'same-origin',

          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }
      );

      if (!cartResponse.ok) {
        throw new Error(
          'Kurven kunne ikke opdateres.'
        );
      }

      const cart =
        await cartResponse.json();

      /*
       * De renderede sections fra cart/add.js
       * lægges på cart-objektet.
       *
       * Det er dem FoxTheme bruger til at
       * erstatte "Din kurv er tom" med den
       * rigtige nye cart drawer.
       */

      cart.sections =
        addResult.sections || {};

      const hasRenderedSections =
        cart.sections &&
        Object.keys(cart.sections).length > 0;

      if (hasRenderedSections) {
        publishCart(cart);
      } else {
        /*
         * Fallback hvis Shopify mod forventning
         * ikke returnerer sections.
         */

        publishCart(cart);
        refreshDrawerFallback();
      }

      button.textContent =
        'Pakken er tilføjet ✓';

      showMessage(
        root,
        'Pakken er lagt i kurven.'
      );

      /*
       * Åbn først draweren efter FoxTheme
       * har fået mulighed for at rendre
       * den nye HTML.
       */

      window.setTimeout(() => {
        openCartDrawer(button);
      }, 60);

      /*
       * Reset knappen.
       */

      window.setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;

        root.classList.remove(
          'is-loading'
        );
      }, 1200);

    } catch (error) {
      console.error(
        'Smart Makro bundle:',
        error
      );

      showMessage(
        root,
        error.message ||
          'Der opstod en fejl. Prøv igen.',
        true
      );

      button.textContent = originalText;
      button.disabled = false;

      root.classList.remove(
        'is-loading'
      );
    }
  };

  const initBundle = (root) => {
    if (
      !root ||
      root.dataset.smBundleInitialized === 'true'
    ) {
      return;
    }

    root.dataset.smBundleInitialized =
      'true';

    const toggle =
      root.querySelector(
        '[data-sm-bundle-toggle]'
      );

    const actions =
      root.querySelector(
        '[data-sm-bundle-actions]'
      );

    const add =
      root.querySelector(
        '[data-sm-bundle-add]'
      );

    if (toggle && actions) {
      toggle.addEventListener(
        'click',
        () => {
          const open =
            !root.classList.contains(
              'is-open'
            );

          root.classList.toggle(
            'is-open',
            open
          );

          toggle.setAttribute(
            'aria-expanded',
            String(open)
          );

          actions.hidden = !open;
        }
      );
    }

    if (add) {
      add.addEventListener(
        'click',
        () => {
          addBundle(root, add);
        }
      );
    }
  };

  const initAll = () => {
    document
      .querySelectorAll(
        '[data-sm-bundle]'
      )
      .forEach(initBundle);
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll,
      {
        once: true
      }
    );
  } else {
    initAll();
  }

  document.addEventListener(
    'shopify:section:load',
    initAll
  );
})();